<template>
    <div >
      
    
        <img  style="margin: 15px;"  :src="require('@/assets/FairfieldCouncil.svg')" alt="Council Logo" />
     
    </div>
  </template>
  <script>

  </script>
  
  